/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterDoctorDto } from '../../models/filter-doctor-dto';
import { ResponseDoctorDto } from '../../models/response-doctor-dto';

export interface DoctorsControllerFilter$Params {
  
    /**
     * The filtering criteria
     */
    body: FilterDoctorDto
}

export function doctorsControllerFilter(http: HttpClient, rootUrl: string, params: DoctorsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseDoctorDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorsControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseDoctorDto>>;
    })
  );
}

doctorsControllerFilter.PATH = '/thalea-doctors/doctors/filter';
